module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAAZBAMAAADOJ2OnAAAAAXNSR0IB2cksfwAAAAlwSFlzAAALEwAACxMBAJqcGAAAABJQTFRFAAAAgICA6kM1JDdtVVWq////2stclQAAAAZ0Uk5TAAL/DgMBnNccXwAAAFxJREFUeJx1j8ENgDAMAy3EBJ0geIKOgJgAsf8wNGnclgd+RCc7UV0AhaShaSMT2SWLrLiSTGGLP8Ni+Z+Kluet6xhv2EL7aDC7LP06nVDsgEf/iPgOgkI3LQlhvdh8Fe6CyUtFAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./images/bw_map_marker.png
// module id = 1434
// module chunks = 0